export default {
  // service.create
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.requirement.message':
    'Please enter the Health Check name',
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.too_long.message':
    'Health Check name is too long',
  'service.create.save_service_status_check_form.generate_status_check_validation_schema.status_check_name.already_exists.message':
    'Health Check name already exists',
  'service.create.service_status_check_table.description.paragraph1.fragment3':
    '. Learn how to add',
  'service.create.service_status_check_table.description.paragraph1.fragment4':
    'to your Service.',
  'service.create.service_status_check_table.description.paragraph2':
    'Once connected, your Health Check monitor will help Gremlin determine how well your Services are weathering Reliability Tests. When Gremlin sees your monitor alerting, Reliability Tests will be automatically halted for this Service.',
  'service.create.service_status_check_table.description.paragraph1.link2.label':
    'Team Settings',
  'services.create.k8s_access_request.btn_cancel': 'Cancel',
  'services.create.k8s_access_request.btn_submit': 'Request Access',
  'services.create.k8s_access_request.description1':
    'Gremlin sees some namespaces that other teams within your company own that could help you get started without enabling process collection. Do you want to request access to any of the namespaces in the below clusters?',
  'services.create.k8s_access_request.description2':
    'Once access is granted, you will be able to proceed with service creation.',
  'services.create.k8s_access_request.cluster_selection.label':
    'Select clusters',
  'services.create.k8s_access_request.cluster_selection.placeholder':
    'Cluster name',

  'services.create.k8s_access_request.label': 'Shareable Namespaces',
  'services.create.k8s_access_request.empty': 'No shareable namespaces to show',
  'services.create.k8s_access_request.loading_error':
    'An error occurred while loading data',
  'services.create.k8s_access_request.list.search': 'Search namespaces',
  'services.create.k8s_access_request.list.headers.cluster_name':
    'Cluster Name',
  'services.create.k8s_access_request.list.headers.namespace':
    'Shared Namespace',
  'services.create.k8s_access_request.list.headers.request_status':
    'Request Status',
  'services.create.k8s_access_request.list.headers.owner': 'Owner',
  'services.create.k8s_access_request.submit.success_message':
    'Request successfully sent. Check in with your team or company manager and return to the service creation flow once access is granted.',
  'service.details.incomplete_service_guide.completed_section.status_check_added.title':
    'Health Check added',
  'service.details.incomplete_service_guide.getting_started.add_status_check.title':
    'Add a Health Check',
  'service.details.incomplete_service_guide.getting_started.add_status_check.paragraph':
    "Each of your services will need a Health Check to evaluate whether your Reliability Tests have passed or failed. Gremlin will work with your existing observability and monitoring tools to automatically halt tests that are causing your Service to fail. If you don't have your monitors set up yet, we recommend setting up monitors that look at: latency, traffic, error rate, and resource saturation.",
  'service.incomplete.warning': 'To run Reliability Tests, add a Health Check',
  'service.details.incomplete_service_guide.getting_started.run_a_test.paragraph':
    'Pick a test below to run on your Service. Your Health Check will tell Gremlin whether a reliability test has passed or failed. It will also tell Gremlin when to halt the test, if necessary.',
  'service.details.risk-widget.title': 'Detected Risks',
  'service.details.dependencies-widget.title': 'Dependencies',

  // service.details.dependency_list
  'service.details.dependency_list.feature_name_plural': 'Dependencies',
  'service.details.dependency_list.page_title': 'Dependencies: {{serviceName}}',
  'service.details.dependency_list.test_status.never_run.tooltip':
    'Test has yet to be run',
  'service.details.dependency_list.test_status.running.button_label': 'View',
  'service.details.dependency_list.test_history_link.aria_label':
    'View Last Run',
  'service.details.dependency_list_page.service_error':
    'There was a problem loading this Service, or it does not exist.',
  'service.details.dependency_list.dependency_grid.empty':
    'No Tests for this Dependency',

  // service.incomplete
  'service.incomplete.warning.scheduling':
    'To schedule Reliability Tests, add a Health Check',

  // service.reliability_test
  'service.reliability_test.in_progress':
    'A reliability test is in progress. Wait for it to finish before starting another reliability test.',

  // service.reliability_test_history
  'service.reliability_test_history.run_list.source.manual': 'Manual',
  'service.reliability_test_history.run_list.source.scheduled': 'Scheduled',

  // service.settings
  'service.settings.status_checks.remove.button.label': 'Remove',
  'service.settings.status_checks.remove.modal.title.text':
    'Remove Health Check?',
  'service.settings.status_checks.remove.modal.message.text':
    '{{statusCheckName}} will be removed from this Service',
  'service.settings.status_checks.remove.modal.cancel.button.label': 'Cancel',
  'service.settings.status_checks.add.button.label': 'Add',
  'services.settings.service_autoscheduling.description':
    'Gremlin can automatically schedule recurring Reliability Tests for this service when given a testing window. We will run this Service’s Reliability Tests during your specified window. This is optional.',
  'services.settings.service_autoscheduling.enabled_text1':
    'Autoschedule eligible',
  'services.settings.service_autoscheduling.enabled_text2':
    'Reliability Tests in this Service',
  'services.settings.service_autoscheduling.enabled_tooltip1':
    'Any dependencies marked as a',
  'services.settings.service_autoscheduling.enabled_tooltip2':
    'Single Point of Failure dependency',
  'services.settings.service_autoscheduling.enabled_tooltip3':
    'will be excluded from an autoscheduled test.',
  'services.settings.service_autoscheduling.text.window.header': 'Test Window',
  'services.settings.service_autoscheduling.text.window.description':
    'Select one day per week for your eligible Reliability Tests to run. Gremlin will run as many of the eligible Reliability Tests that it can during the specified window. At a minimum, we will need a four hour window.',

  // common
  'service.common.feature_name_plural': 'Services',
  'service_common.detected_risks.pending.tooltip':
    'Risk evaluation is pending for this service',
  'service_common.detected_risks.unavailable': 'n/a',
  'service_common.detected_risks.unavailable.tooltip':
    'No risks could be evaluated for this Service',
  'service_common.detected_risks.no_deployment.tooltip':
    'No risks evaluated because this service is not deployed',
  'service_common.detected_risks.not_included.tooltip':
    'No risks evaluated because all risks were ignored in the Test Suite',

  'service_common.k8s_access_request.sent.success': 'Request successfully sent',
  'service_common.k8s_access_request.sent.fail':
    'There was an issue requesting access. Please try again later.'
}
